import { useRef } from "react";
import { useAppDispatch } from "../store/hooks/StoreHooks";
import { autoLogin, fetchAllCustomers, fetchUser, fetchUsermenu, login, logout, postRefreshToken, setIsLoggedIn } from "../store/dashboard/AuthSlice";

const AuthFacade = () => {
    const dispatch = useAppDispatch();
    const refreshTokenRef = useRef<NodeJS.Timeout | null>(null);

    const tokenLogin = (ref: string | null) => {
        return dispatch(login(ref));
    }

    const validateLogin = () => {
        return dispatch(autoLogin());
    };

    const applogout = () => {
        dispatch(logout());
        setIsLoggedIn(false);
    };

    const getUser = () => {
        return dispatch(fetchUser());
    };

    const getUserMenu = (payload: any) => {
        return dispatch(fetchUsermenu(payload));
    };

    const getAllCustomers = (companay: string) => {
        return dispatch(fetchAllCustomers(companay));
    };

    const refreshToken = async () => {
        const body = {
            'token': '' + localStorage.getItem("Token")
        };
        return await dispatch(postRefreshToken(body))
            .then((response) => {
                if (response?.payload) {
                    localStorage.setItem("Token", response?.payload?.token);
                    startRefreshToken();
                    setIsLoggedIn(true);
                } else {
                    setIsLoggedIn(false);
                }
            });
    }

    const startRefreshToken = () => {
        clearInterval(refreshTokenRef.current as NodeJS.Timeout);
        refreshTokenRef.current = setInterval(() => {
            refreshToken();
        }, 60 * 60 * 1000);
    };

    const clearTokenInterval = () => {
        if (refreshTokenRef.current) {
            clearInterval(refreshTokenRef.current);
            refreshTokenRef.current = null;
        }
    };

    return {
        tokenLogin,
        validateLogin,
        applogout,
        getUser,
        getUserMenu,
        startRefreshToken,
        clearTokenInterval,
        getAllCustomers,
    };
};

export default AuthFacade;